import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  mark(event) {
    const item = this.element

    item.classList.remove("notification-item--unread")
    const dot = item.querySelector(".notification-item__dot")
    if (dot) dot.remove()

    const badge = document.querySelector(".notification-badge")
    if (badge) {
      const count = parseInt(badge.textContent) - 1
      if (count <= 0) {
        badge.remove()
      } else {
        badge.textContent = count > 9 ? "9+" : count
      }
    }

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Content-Type": "application/json"
      }
    })
  }
}